export const endpoint = {
    base: {
        enum: "/enum",
        city_state: "/state-cities",
        send_otp: "/otp",
        verify_otp: "/otp/verify",
    },
    institute: {
        enum: "/enum",
        detail: "/detail",
        programs: "/programs",
    },
    admissions: {
        enum: "/enum",
        courseFee: "/fee",
        application_fee: "/application/fee",
        submit: "/request",
    },
    student: {
        enum: "/enum",
    }
};
